export const SHIP_OPTION_GROUP_EGC = 'SHIP_OPTION_GROUP_EGC';
export const SHIP_OPTION_GROUP_RETAIL_W_OPTIONS = 'SHIP_OPTION_GROUP_RETAIL_W_OPTIONS';
export const SHIP_OPTION_GROUP_RETAIL_WO_OPTIONS = 'SHIP_OPTION_GROUP_RETAIL_WO_OPTIONS';
